import { Grid, Button, FormControl, InputLabel, MenuItem, Typography, IconButton, Link } from "@material-ui/core";
import Icd9CodeAutocomplete from "../Icd9CodeAutocomplete/Icd9CodeAutocomplete";
import { FieldArray, Form, useFormikContext } from "formik";
import { Icd9Code, Observation, Procedure } from "../../../types/referrals";
import i18nNamespaces from "../../../const/i18nNamespaces";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import { SIDES } from "../../../const/referral";
import { ReferralFormValues } from "../../../pages/NewReferralPage/NewReferralPage";
import { Remove, RemoveCircleOutline, RemoveOutlined } from "@material-ui/icons";
import { useState } from "react";
import useStyles from '../../../pages/NewReferralPage/NewReferralPageStyles';
import clsx from "clsx";

const ProceduresInputs = () => {
    const formik = useFormikContext<ReferralFormValues>();
    const {t} = useTranslation(i18nNamespaces.REFERRAL);
    const classes = useStyles();

    return (
        <>          
        <FieldArray name="procedures">
            {({ push, remove }) => (
                <>
                    {formik.values.procedures && formik.values.procedures.map((pro: Procedure, idx: number) => (
                        <Grid container item spacing={2} key={idx} className={clsx({[classes.secondaryBlockContainer]: idx > 0})}>
                            <Grid item md={6} xs={12}>
                                <Icd9CodeAutocomplete
                                    label={t('procedure')}
                                    icd9Code={pro.icd9Code || null}
                                    onChange={newValue =>
                                        formik.setFieldValue(`procedures[${idx}].icd9Code`, newValue)
                                    }
                                    error={
                                        Boolean(formik.touched.procedures && formik.errors.procedures)
                                    }
                                />
                            </Grid>
                            {idx > 0 && (
                                <Grid item md={1} xs={12} className={classes.removeButtonContainer}>
                                    <IconButton color="secondary" onClick={() => remove(idx)} disabled={formik.values.procedures.length === 1}>
                                        <RemoveCircleOutline fontSize="small"/>
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    ))}
                    <Grid item xs={12}>
                        <Link color="secondary" className={classes.link} onClick={() => push({ icd9Code: null, targetSite: null })}>
                            {t('addProcedure')}
                        </Link>
                    </Grid>
                </>
            )}
        </FieldArray>
        </>
    );
};

export default ProceduresInputs;